(function () {
    angular.module('components.customForm')
        .factory('customFormService', customFormService);

    customFormService.$inject = ['$http'];
    function customFormService($http) {
        return {
            getForm: function (formUrl) {
                return $http.get('/api/form', {
                    cache: true,
                    params: {
                        url: formUrl
                    }
                });
            }
        };
    }
})();